import React, { Component } from 'react';
import PopupColorPicker from '../../common/colorpicker/PopupColorPicker';
import { MarkerIcon, shapes } from '../../survey/heatmap/Marker';
import classnames from 'classnames';
import { CustomPicker } from 'react-color';

class MarkerWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shape: this.props.shape || shapes[0],
    };
    this.submitter = null;
  }

  onMarkerClick(shape) {
    this.setState({
      shape,
    });
  }

  render() {
    const { shape } = this.state;
    return (
      <PopupColorPicker
        {...this.props}
        customChangeTrigger={shape}
        className="d-ib btn-one fs-12"
        debounce={1000}
        submitter={this.submitter}
      >
        {[
          ({ getTriggerRef, hex, onClick }) => (
            <button
              onClick={onClick}
              type="button"
              className="input-reset"
              ref={getTriggerRef}
            >
              <MarkerIcon
                className="pointer dim"
                color={hex}
                shape={shape}
                style={{ verticalAlign: 'text-bottom' }}
                radius={15}
              />
              <input
                type="hidden"
                name="row[color]"
                value={hex}
                ref={node => (this.submitter = node)}
              />
              <input type="hidden" name="row[shape]" value={shape} />
            </button>
          ),
          ({ hex }) => (
            <div className="pt-10 mt-16 b-t-eee">
              <div className="d-flex align-center jc-between">
                {shapes.map(s => (
                  <button
                    type="button"
                    onClick={this.onMarkerClick.bind(this, s, hex)}
                    className="input-reset"
                    key={s}
                  >
                    <MarkerIcon
                      className={classnames(
                        'trans-prop-all trans-duration-2 pointer',
                        {
                          'o-50': s !== shape,
                          'scale-120': s === shape,
                        }
                      )}
                      color={hex}
                      radius={12}
                      shape={s}
                    />
                  </button>
                ))}
              </div>
            </div>
          ),
        ]}
      </PopupColorPicker>
    );
  }
}
export default CustomPicker(MarkerWidget);
